export const isFill = (value?: string) => value !== '' && value !== undefined && value !== null;
